import {
  PatientPointDataListActionType,
  PATIENT_DATA_POINT_FAIL,
  PATIENT_DATA_POINT_LOADING,
  PATIENT_DATA_POINT_SUCCESS,
  AddPatientPointDataState,
} from "./ActionTypes";
import { PatientDemographicsDetails } from "./Model";

const initialStateGetPosts: AddPatientPointDataState = {
  loading: false,
  patientDemographicsRes: {} as PatientDemographicsDetails,
  pageCount: 0,
};
export const getPatientDataPointListReducer = (
  state = initialStateGetPosts,
  action: PatientPointDataListActionType
): AddPatientPointDataState => {
  switch (action.type) {
    case PATIENT_DATA_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        patientDemographicsRes: action.payload,
        pageCount: action.pageCount,
      };
    case PATIENT_DATA_POINT_LOADING:
      return {
        ...state,
        loading: true,
        patientDemographicsRes: {} as PatientDemographicsDetails,
      };
    case PATIENT_DATA_POINT_FAIL:
      return {
        ...state,
        patientDemographicsRes: {} as PatientDemographicsDetails,
        loading: false,
      };
    default:
      return state;
  }
};
